import React, { useContext, useState } from "react";
import {
  MedicineCardWrapper,
  MedicineCardContainer,
  MedicineCardFloatingWrapper,
  MedicineCardFixedWrapper,
  MedicineCardTopWrapper,
} from "./medicineCard.style";
import { CiEdit } from "react-icons/ci";
import { Checkbox, message, Tooltip } from "antd";
import { MedViewer } from "../index";
import { newApiCallHandler } from "../../../services/packslip.service";
import { CheckerService_URL } from "../../../redux/Url";
import QtyModal from "../QtyModal";
import { MdPending } from "react-icons/md";
import { FaBoxOpen, FaBox } from "react-icons/fa";
import { Context } from "../../../pages/PackSlip";
const STATUS_MAP = {
  PENDING: {
    label: "Pending",
    color: "#fca311",
    icon: <MdPending />,
  },
  PARTIALLY_PACKED: {
    label: "Partially Packed",
    color: "#2f65cb",
    icon: <FaBoxOpen />,
  },
  PACKED: {
    label: "Packed",
    color: "#22b573",
    icon: <FaBox />,
  },
};

const MedicineCard = ({ data, onSelect, psData }) => {
  const { sourceBox, destinationBox, transferOrderId } = psData;

  const {
    productCode,
    productName,
    pendingQty,
    totalQty,
    batchNumber,
    checked,
    id,
    packedQty,
  } = data;
  const { setIsLoading } = useContext(Context);
  const [isModalOpen, setIsModalOpen] = useState(false);

  let status;
  if (pendingQty === 0) {
    status = STATUS_MAP.PACKED;
  } else if (pendingQty === totalQty) {
    status = STATUS_MAP.PENDING;
  } else {
    status = STATUS_MAP.PARTIALLY_PACKED;
  }

  const handleSelect = ({ isEdit, checked, quantity }) => {
    setIsLoading(true);

    newApiCallHandler({
      method: "POST",
      url: `${CheckerService_URL}/packing/boxes/products`,
      data: [
        {
          productCode: productCode,
          productName: productName,
          packedQty: isEdit ? quantity : checked ? totalQty : 0,
          batchNumber: batchNumber,
          checked: checked,
        },
      ],
      params: {
        boxFull: false,
        transferOrderId: transferOrderId,
        destinationBox: destinationBox,
        sourceBox: sourceBox,
        packed: false,
      },
      onSuccess: (res, error) => {
        if (error) {
          console.log(error);
          message.error(error);
          return;
        }
        onSelect(id, checked, quantity);
      },
      onFailure: (err) => {
        message.error(err);
        setIsLoading(false);
      },
    });
  };
  return (
    <MedicineCardContainer>
      <MedicineCardWrapper checked={checked}>
        <MedicineCardFloatingWrapper>
          <MedicineCardTopWrapper>
            <div className="status" style={{ backgroundColor: status.color }}>
              {status.icon} {status.label}
            </div>
            <div className="bactchWrapper">
              <div className="batchLabel">Batch :</div>
              <div className="batchNumber">{batchNumber}</div>
            </div>
          </MedicineCardTopWrapper>

          <div className="edit" onClick={() => setIsModalOpen(true)}>
            <CiEdit size={22} />
          </div>
        </MedicineCardFloatingWrapper>
        <MedicineCardFixedWrapper>
          <div>
            <Checkbox
              onChange={(e) => handleSelect({ checked: e.target.checked })}
              checked={checked}
              size="large"
            />
          </div>
          <div className="MedicineCardInfo">
            <div className="medicineWrapper">
              <Tooltip
                placement="top"
                title={data.productName}
                autoAdjustOverflow={true}
              >
                <div className="medicineName">{data.productName}</div>
              </Tooltip>
              <div className="medicineInfo">
                <MedViewer productCode={productCode} />
              </div>
            </div>

            <div className="medicineQtyWrapper">
              Pending <span>{data?.pendingQty ?? 0}</span> of total quantity
              <span>{data?.totalQty ?? 0}</span>
            </div>
          </div>
        </MedicineCardFixedWrapper>
      </MedicineCardWrapper>
      {isModalOpen && (
        <QtyModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          handleSelect={(props) => {
            handleSelect(props);
            setIsModalOpen(false);
          }}
          packedQty={packedQty}
          totalQty={totalQty}
          pendingQty={pendingQty}
        />
      )}
    </MedicineCardContainer>
  );
};

export default MedicineCard;
